const STORAGE_KEY = 'searchProductLayout';

export const SEARCH_PRODUCT_LAYOUTS = {
  horizontal: 'horizontal',
  vertical: 'vertical',
};

export function getSearchProductLayout() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === SEARCH_PRODUCT_LAYOUTS.vertical || stored === SEARCH_PRODUCT_LAYOUTS.horizontal) {
      return stored;
    }
  } catch {
    // ignore
  }

  return SEARCH_PRODUCT_LAYOUTS.vertical;
}

export function setSearchProductLayout(layout) {
  if (layout !== SEARCH_PRODUCT_LAYOUTS.vertical && layout !== SEARCH_PRODUCT_LAYOUTS.horizontal) {
    return;
  }

  try {
    localStorage.setItem(STORAGE_KEY, layout);
  } catch {
    // ignore
  }
}
